<template>
    <div>
        <div>
            <Button class="btn-info ml-auto" label="Edit User Assessment" @click="updateUserAssessment" />
        </div>
        <!-- User Block Answers which have been previously submitted load only after answers have been loaded -->
        <UserProfileBlock :userId="props.userId" />

        <!-- Begin new assessment for client -->
        <div class="card">

            <div class="flex mt-2" v-if="!isCstOnly">
                <h5 class="col-2 mt-2">New Assessment:</h5>
                <div class="col-2">
                    <AssessmentDropdown v-model="selectedAssessment" />
                </div>
                <div class="col-2">
                    <Button label="Begin Assessment" :disabled="!selectedAssessment" @click="startAssessment" />
                </div>
            </div>

            <template v-for="(product, index) in cstProducts()" :key="product.id">

                <divider v-if="index === 0 && !isCstOnly"/>

                <div class="flex mt-2" v-if="product.code?.startsWith('CST-')">

                    <div class="col-2 mt-2 flex align-items-center">
                        <img
                            v-if="index === 0"
                            :src="'/layout/images/CST-S.png'"
                            :alt="product?.description"
                            class="ml-6"
                            style="max-height: 33px; width: auto; overflow: hidden;"
                        />
                    </div>
                    <div class="flex col-2 align-items-center">
                        {{product.code}} {{product.description}}
                    </div>
                    <div class="col-2 flex align-items-center">
                        <Button label="Begin Assessment" @click="startCstV1Assessment" v-if="product.code === 'CST-V1'" />
                    </div>
                </div>
            </template>

        </div>
        <!-- Submitted Answers Table -->
        <AnswersTable :userId="props.userId" v-if="!isCstOnly" />
    </div>
</template>

<script setup>
import UserProfileBlock from './UserProfileBlock.vue';
import AssessmentDropdown from '../../../../pha/components/AssessmentDropdown';
import AnswersTable from '../components/AnswersTable.vue';

import { ref, defineProps } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/store';

// Props
const props = defineProps({
    userId: {
        type: [String, Number],
        required: true,
    },
});

const router = useRouter();
const selectedAssessment = ref(null);

// Redirects to Assessment entry point
const startAssessment = () => {
    if (selectedAssessment.value) {
        router.push({ name: 'AnswerAssessment', params: { assessmentCode: selectedAssessment.value, userId: props.userId } });
    }
};

function startCstV1Assessment() {
    router.push({ name: 'cst_v1_assessment', params: { id: props.userId } });
}

// Redirects to UserBlock assessment form
const updateUserAssessment = () => {
    router.push({ name: 'AnswerAssessment', params: { assessmentCode: 'user_profile', userId: props.userId } });
};

const products = store.getters['auth/getProducts'];
const isCstOnly = store.getters['auth/isCstOnly'];

function cstProducts() {
    return products.filter((product) => {
        return product.code?.startsWith('CST-')
    })
}
</script>
